import { PhaseProjectsView } from "@/components/features/settings/defaults/matter-phase-projects/PhaseProjectsView";
import { PhaseProjectLibraryView } from "@/components/features/settings/defaults/matter-phase-projects/PhaseProjectLibraryView";
import { Button, Text } from "@/components/ui";
import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { Info } from "lucide-react";
import { useState } from "react";

export default function MatterPhaseSettingsView() {
  const [showLibrary, setShowLibrary] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Text variant="title">Matter phases</Text>
        <TooltipWrapper
          message={
            <div className="space-y-2 text-sm leading-5">
              <p>
                <strong>Projects</strong> choose which incident types use an
                ordered set of phases.
              </p>
              <p>
                <strong>Phases</strong> are reusable stages within a project.
              </p>
              <p>
                <strong>Actions</strong> are the checks within a phase that
                track its progress. Widgets display matter information.
              </p>
            </div>
          }
        >
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="text-muted-foreground size-7"
            aria-label="How phase projects work"
          >
            <Info className="size-4" aria-hidden="true" />
          </Button>
        </TooltipWrapper>
      </div>
      {showLibrary ? (
        <PhaseProjectLibraryView
          onBack={() => {
            setShowLibrary(false);
          }}
          backLabel="Phase projects"
        />
      ) : (
        <PhaseProjectsView
          onManageLibrary={() => {
            setShowLibrary(true);
          }}
        />
      )}
    </div>
  );
}
